/* ============================================================================
   GAMBAR PRODUK — Control Panel tab Flow (v3.9) · enjin RESIPI (31 Okt 2026)
   ============================================================================
   Muncul HANYA bila module aktif ialah resipi "gambar berlainan setiap scene" (App.jsx).
   Pelanggan pilih scene mana guna gambar produk sebagai rujukan.
   ⛔ RUPA SAHAJA — tiada simpanan di sini. Nilai + simpanan: App.jsx `rujukanProduk` / `pilihRujukanProduk`
      (utils/rujukanProduk.js). Rupa = KEMBAR HasilSceneV39.jsx (supaya dua seksyen sebaris).
   ========================================================================== */
import { useT } from '../i18n';

export default function RujukanProdukV39({ nilai = 'semua', onPilih }) {
    const t = useT();
    return <SeksyenRadioV39 tajuk={t('workspace.productRef.title')} nilai={nilai} onPilih={onPilih} pilihan={[
        { id: 'semua', tajuk: t('workspace.productRef.optAll'), nota: t('workspace.productRef.optAllDesc') },
        { id: 'pertama', tajuk: t('workspace.productRef.optFirst'), nota: t('workspace.productRef.optFirstDesc') },
        { id: 'akhir', tajuk: t('workspace.productRef.optLast'), nota: t('workspace.productRef.optLastDesc') },
        { id: 'tiada', tajuk: t('workspace.productRef.optNone'), nota: t('workspace.productRef.optNoneDesc') },
    ]} />;
}

/* Images only: gambar hasil disimpan di mana. */
export function SimpanGambarV39({ nilai = 'folder', onPilih }) {
    const t = useT();
    return <SeksyenRadioV39 tajuk={t('workspace.imageSave.title')} nilai={nilai} onPilih={onPilih} pilihan={[
        { id: 'folder', tajuk: t('workspace.imageSave.optFolder'), nota: t('workspace.imageSave.optFolderDesc') },
        { id: 'kad', tajuk: t('workspace.imageSave.optCard'), nota: t('workspace.imageSave.optCardDesc') },
    ]} />;
}

/* Images only: berapa gambar setiap prompt. */
export function BilOutputV39({ nilai = '1', onPilih }) {
    const t = useT();
    return <SeksyenRadioV39 tajuk={t('workspace.imageOutputs.title')} nilai={nilai} onPilih={onPilih} pilihan={['1', '2', '3', '4'].map((n) => ({
        id: n,
        tajuk: t('workspace.imageOutputs.opt', { n }),
        nota: n === '1' ? t('workspace.imageOutputs.optOneDesc') : t('workspace.imageOutputs.optManyDesc', { n }),
    }))} />;
}

function SeksyenRadioV39({ tajuk, pilihan, nilai, onPilih }) {
    return (
        <div className="s-sect" style={{ padding: '0 0 16px', borderBottom: '1px solid var(--s-line)', marginBottom: 16 }}>
            <p className="s-sect__title">{tajuk}</p>
            <div role="radiogroup" aria-label={tajuk} style={{ display: 'grid', gap: 6 }}>
                {pilihan.map((p) => {
                    const on = nilai === p.id;
                    return (
                        <button
                            key={p.id}
                            type="button"
                            role="radio"
                            aria-checked={on}
                            onClick={() => onPilih?.(p.id)}
                            style={{
                                display: 'flex', alignItems: 'flex-start', gap: 10,
                                width: '100%', textAlign: 'left', font: 'inherit',
                                padding: '10px 12px', borderRadius: 10, cursor: 'pointer',
                                background: on ? 'var(--s-fill)' : 'transparent',
                                border: `1px solid ${on ? 'var(--s-select)' : 'var(--s-line-strong)'}`,
                                color: 'var(--s-ink)',
                            }}
                        >
                            <span
                                aria-hidden="true"
                                style={{
                                    width: 16, height: 16, borderRadius: '50%', flex: 'none', marginTop: 2,
                                    border: `1.5px solid ${on ? 'var(--s-select)' : 'var(--s-ink-3)'}`,
                                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                                }}
                            >
                                {on && <span style={{ width: 8, height: 8, borderRadius: '50%', background: 'var(--s-select)' }} />}
                            </span>
                            <span style={{ minWidth: 0 }}>
                                <span style={{ display: 'block', fontSize: 13, fontWeight: 500, lineHeight: 1.4 }}>{p.tajuk}</span>
                                <span className="s-hint" style={{ display: 'block', margin: '2px 0 0' }}>{p.nota}</span>
                            </span>
                        </button>
                    );
                })}
            </div>
        </div>
    );
}
